import { resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "router-view" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component, route }) => [
        _createVNode(_Transition, { name: "router" }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component), _mergeProps({
              key: route.name
            }, route.props), null, 16 /* FULL_PROPS */))
          ]),
          _: 2 /* DYNAMIC */
        }, 1024 /* DYNAMIC_SLOTS */)
      ]),
      _: 1 /* STABLE */
    }),
    _createElementVNode("div", {
      class: "router-backdrop bg-glass-dark overflow-hidden",
      onClick: _cache[0] || (_cache[0] = (...args) => ($options.close && $options.close(...args))),
      onTouchmove: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop","prevent"])),
      onWheel: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop","prevent"]))
    }, null, 32 /* NEED_HYDRATION */)
  ]))
}